import * as i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// import Backend from 'i18next-http-backend';
import ChainedBackend from 'i18next-chained-backend';
import HttpBackend from 'i18next-http-backend';
import LocalStorageBackend from 'i18next-localstorage-backend';
import globalConfig from './config/globalConfig';

i18n
  .use(ChainedBackend)
  .use(initReactI18next)
  // Order is important here!
  //  If we don't specify a namespace in useTranslation() or in t('ns:key'),
  //  i18n will use the first namespace
  .init({
    ns: [
      'login',
      'common',
      'trips',
      'trip',
      'errors',
      'passengers',
      'library',
      'services',
      'bookings',
      'embed',
      'settings',
      'trippricing'
    ],
    fallbackLng: 'en',
    debug: !globalConfig.isProduction,
    interpolation: {
      escapeValue: false
    },
    backend: {
      backends: [LocalStorageBackend, HttpBackend],
      backendOptions: [
        {
          // expirationTime: 7 * 24 * 60 * 60 * 1000 // 7 days
          expirationTime: 5 * 60 * 1000, // 5 minutes
          cache: true
        },
        // Removing characters from the epoch timestamp serves as a sort of cache-busting
        //  Remove 5 characters: Valid for ~2 min
        //  Remove 6 characters: Valid for ~20 min
        //  Remove 7 characters: Valid for ~3 hours
        {
          loadPath:
            '/locales/{{lng}}/{{ns}}.json?cb=' +
            Date.now().toString().slice(0, -5)
        }
      ]
    }
  });

export default i18n;
